import TYPES from '@/types';

// Application
import { ResetIdentityVerificationStatus } from '@/modules/on-boarding/identity-verification/application/services';
import GetOnBoardingPersonQuery from '@/modules/on-boarding/person/application/queries/get-on-boarding-person-query';
import RequestUpdateCustomerDocumentIneCommand
  from '@/modules/customer/customer-documents/application/commands/request-update-customer-document-ine-command';

// Domain
import { Values } from '@/modules/shared/domain/i18n/types';
import Inject from '@/modules/shared/domain/di/inject';
import Translator from '@/modules/shared/domain/i18n/translator';
import { Router } from '@/modules/shared/domain/router';
import { MessageNotifier } from '@/modules/shared/domain/notifiers/message_notifier';

export default class UpdateIdentityDocumentViewModel {
  @Inject(TYPES.ON_BOARDING_RESET_IDENTITY_VERIFICATION_STATUS)
  readonly reset_identity_verification_status!: ResetIdentityVerificationStatus;

  @Inject(TYPES.GET_ON_BOARDING_PERSON_QUERY)
  private readonly get_onboarding_person!: GetOnBoardingPersonQuery;

  @Inject(TYPES.REQUEST_UPDATE_CUSTOMER_DOCUMENT_INE_COMMAND)
  private readonly request_update_ine_cmd!: RequestUpdateCustomerDocumentIneCommand;

  @Inject(TYPES.NOTIFIER)
  readonly message_notifier!: MessageNotifier;

  @Inject(TYPES.I18N)
  readonly translator!: Translator;

  @Inject(TYPES.ROUTER)
  private readonly router!: Router;

  private readonly i18n_namespace = 'components.update-identity-document';

  identity_document_updated = false;

  allow_update_identity_document = false;

  authenticated_customer = false;

  is_loading = false;

  translate = (message: string, values?: Values) => this.translator.translate(`${this.i18n_namespace}.${message}`, values);

  goToLoginPage = () => {
    window.location.href = '/login';
  }

  deleteTokenFromStorage = () => {
    sessionStorage.clear();
  }

  setUserId = (token: string) => {
    const payload = JSON.parse(Buffer.from(token.split('.')[1], 'base64')
      .toString());
    sessionStorage.setItem('user_id', payload.customer_id);
  }

  setTokenToStorage = (token: string) => {
    sessionStorage.setItem('authorization', token);
  }

  showConfirmation = () => {
    this.identity_document_updated = true;
  }

  validateIdentityDocumentExpired = async () => {
    try {
      this.is_loading = true;
      await this.request_update_ine_cmd.execute();
      setTimeout(() => {
        const reload_customer_notifications = new CustomEvent('reload.customer.notifications', { detail: { } });
        window.dispatchEvent(reload_customer_notifications);
        this.is_loading = false;
        this.allow_update_identity_document = true;
      }, 2000);
    } catch {
      this.is_loading = false;
      this.message_notifier.showInfoNotification(this.translate('request_update_ine'));
    }
  }

  initialize = async (token: string) => {
    this.setTokenToStorage(token);
    this.setUserId(token);
    await this.validateIdentityDocumentExpired();
  }
}
